/** Flat hero/card paths under New Design/images (symlinked as /images). */
const FLAT_BY_SLUG: Record<string, string> = {
  "attabad-lake": "/images/attabad-lake.jpg",
  astola: "/images/astola-island.jpg",
  "astola-island": "/images/astola-island.jpg",
  babusar: "/images/babusar-top.jpg",
  "babusar-top": "/images/babusar-top.jpg",
  badshahi: "/images/badshahi-mosque.jpg",
  deosai: "/images/deosai.jpg",
  "deosai-plains": "/images/deosai.jpg",
  "fairy-meadows": "/images/fairy-meadows.jpg",
  hingol: "/images/hingol.jpg",
  "hingol-national-park": "/images/hingol.jpg",
  hunza: "/images/hunza-valley-rakaposhi.webp",
  "hunza-valley": "/images/hunza-valley-rakaposhi.webp",
  kalam: "/images/kalam-valley.jpg",
  "kalam-valley": "/images/kalam-valley.jpg",
  kalasha: "/images/kalasha-valley.jpg",
  "kalasha-valley": "/images/kalasha-valley.jpg",
  keran: "/images/keran.jpg",
  khewra: "/images/khewra-salt-mine.jpg",
  khunjerab: "/images/khunjerab-pass.jpg",
  "khunjerab-pass": "/images/khunjerab-pass.jpg",
  kund: "/images/kund-malir-beach.jpg",
  "kund-malir": "/images/kund-malir-beach.jpg",
  "kund-malir-beach": "/images/kund-malir-beach.jpg",
  lahore: "/images/lahore-fort.jpg",
  "lahore-fort": "/images/lahore-fort.jpg",
  "lahore-old-city": "/images/lahore-fort.jpg",
  makli: "/images/makli.jpg",
  "makli-necropolis": "/images/makli.jpg",
  malam: "/images/malam-jabba.jpg",
  "malam-jabba": "/images/malam-jabba.jpg",
  moenjodaro: "/images/moenjodaro.jpg",
  naltar: "/images/naltar.jpg",
  "naltar-valley": "/images/naltar.jpg",
  neelum: "/images/neelum-valley.jpg",
  "neelum-valley": "/images/neelum-valley.jpg",
  ratti: "/images/ratti-gali-lake.jpg",
  "ratti-gali": "/images/ratti-gali-lake.jpg",
  "ratti-gali-lake": "/images/ratti-gali-lake.jpg",
  rohtas: "/images/rohtas-fort.jpg",
  saiful: "/images/licensed/lake-saifulmalook.jpg",
  "saiful-malook": "/images/licensed/lake-saifulmalook.jpg",
  sibi: "/images/sibi-mela.jpg",
  skardu: "/images/licensed/unexpected-snow-in-katpana-skardu.jpg",
  takht: "/images/takht-i-bahi.jpg",
  "takht-i-bahi": "/images/takht-i-bahi.jpg",
  taxila: "/images/taxila.jpg",
  wazir: "/images/wazir-khan-mosque.jpg",
  "wazir-khan-mosque": "/images/wazir-khan-mosque.jpg",
  broadbeach: "/images/broadbeach-sonmiani.jpg",
  gadani: "/images/lagoon-gadani.jpg",
  chilam: "/images/chilam-joshi.jpg",
  shandur: "/images/shandur-polo.jpg",
  blossom: "/images/spring-blossom-hunza.jpg",
  hotel: "/images/hotel-hunza.jpg",
  k2: "/images/attractions/k2.webp",
  derawar: "/images/derawar-fort.jpg",
  margalla: "/images/margalla-hills.jpg",
  "margalla-hills": "/images/margalla-hills.jpg",
  ayubia: "/images/resort-ayubia.jpg",
  "resort-ayubia": "/images/resort-ayubia.jpg",
  naran: "/images/riverfront-naran.jpg",
  "riverfront-naran": "/images/riverfront-naran.jpg",
  nankana: "/images/religious-sikh-pilgrimage.jpg",
  "religious-sikh-pilgrimage": "/images/religious-sikh-pilgrimage.jpg",
};

/** Real GreenPak property photos, symlinked from main app public/images/properties. */
export const PROPERTY_CARD: Record<string, string> = {
  "k2-hotel-skardu": "/images/properties/k2-hotel-skardu-0.jpg",
  "greenpak-hotel-hunza": "/images/properties/greenpak-hotel-hunza-0.jpg",
  "greenpak-resort-naltar": "/images/properties/greenpak-resort-naltar-0.jpg",
  "greenpak-riverfront-naran": "/images/properties/greenpak-riverfront-naran-0.jpg",
  "greenpak-hotel-ayubia": "/images/properties/greenpak-hotel-ayubia-0.jpg",
  "greenpak-hotel-balakot": "/images/properties/greenpak-hotel-balakot-0.jpeg",
  "greenpak-resort-chattar-plain": "/images/properties/greenpak-resort-chattar-plain-0.jpg",
  "greenpak-hotel-booni": "/images/properties/greenpak-hotel-booni-0.jpg",
  "greenpak-hotel-kalam": "/images/properties/greenpak-hotel-kalam-0.jpg",
  "greenpak-resort-bansra-gali": "/images/properties/greenpak-resort-bansra-gali-0.jpg",
  "greenpak-hotel-nankana": "/images/properties/greenpak-hotel-nankana-0.jpg",
  "greenpak-hotel-fort-munro": "/images/properties/greenpak-hotel-fort-munro-0.jpg",
  "greenpak-hotel-katas-raj": "/images/properties/greenpak-hotel-katas-raj-0.jpg",
  "greenpak-lagoon-gadani": "/images/properties/greenpak-lagoon-gadani-0.jpg",
  "greenpak-broadbeach-sonmiani": "/images/properties/greenpak-broadbeach-sonmiani-0.jpg",
};

const PROPERTY_GALLERY: Record<string, string[]> = {
  "k2-hotel-skardu": [
    "/images/properties/k2-hotel-skardu-0.jpg",
    "/images/properties/k2-hotel-skardu-2.jpg",
    "/images/properties/k2-hotel-skardu-3.jpg",
    "/images/properties/k2-hotel-skardu-5.jpg",
  ],
  "greenpak-hotel-hunza": [
    "/images/properties/greenpak-hotel-hunza-0.jpg",
    "/images/properties/greenpak-hotel-hunza-1.jpg",
    "/images/properties/greenpak-hotel-hunza-2.jpg",
    "/images/properties/greenpak-hotel-hunza-3.jpg",
  ],
  "greenpak-resort-naltar": [
    "/images/properties/greenpak-resort-naltar-0.jpg",
    "/images/properties/greenpak-resort-naltar-1.jpg",
    "/images/properties/greenpak-resort-naltar-2.jpg",
    "/images/properties/greenpak-resort-naltar-3.jpg",
  ],
  "greenpak-riverfront-naran": [
    "/images/properties/greenpak-riverfront-naran-0.jpg",
    "/images/properties/greenpak-riverfront-naran-1.jpg",
    "/images/properties/greenpak-riverfront-naran-2.jpg",
    "/images/properties/greenpak-riverfront-naran-3.jpg",
  ],
  "greenpak-hotel-ayubia": [
    "/images/properties/greenpak-hotel-ayubia-0.jpg",
    "/images/properties/greenpak-hotel-ayubia-1.jpg",
    "/images/properties/greenpak-hotel-ayubia-2.jpg",
    "/images/properties/greenpak-hotel-ayubia-3.jpg",
  ],
  "greenpak-hotel-balakot": [
    "/images/properties/greenpak-hotel-balakot-0.jpeg",
    "/images/properties/greenpak-hotel-balakot-1.jpeg",
    "/images/properties/greenpak-hotel-balakot-3.jpg",
    "/images/properties/greenpak-hotel-balakot-4.jpg",
  ],
  "greenpak-resort-chattar-plain": [
    "/images/properties/greenpak-resort-chattar-plain-0.jpg",
    "/images/properties/greenpak-resort-chattar-plain-1.jpg",
    "/images/properties/greenpak-resort-chattar-plain-2.jpg",
    "/images/properties/greenpak-resort-chattar-plain-3.jpg",
  ],
  "greenpak-hotel-booni": [
    "/images/properties/greenpak-hotel-booni-0.jpg",
    "/images/properties/greenpak-hotel-booni-1.jpg",
    "/images/properties/greenpak-hotel-booni-2.jpg",
    "/images/properties/greenpak-hotel-booni-3.jpg",
  ],
  "greenpak-hotel-kalam": [
    "/images/properties/greenpak-hotel-kalam-0.jpg",
    "/images/properties/greenpak-hotel-kalam-1.jpg",
    "/images/properties/greenpak-hotel-kalam-2.jpg",
    "/images/properties/greenpak-hotel-kalam-3.jpg",
  ],
  "greenpak-resort-bansra-gali": [
    "/images/properties/greenpak-resort-bansra-gali-0.jpg",
    "/images/properties/greenpak-resort-bansra-gali-1.jpg",
    "/images/properties/greenpak-resort-bansra-gali-2.jpg",
    "/images/properties/greenpak-resort-bansra-gali-3.jpg",
  ],
  "greenpak-hotel-nankana": [
    "/images/properties/greenpak-hotel-nankana-0.jpg",
    "/images/properties/greenpak-hotel-nankana-1.jpg",
    "/images/properties/greenpak-hotel-nankana-2.jpg",
    "/images/properties/greenpak-hotel-nankana-3.jpg",
  ],
  "greenpak-hotel-fort-munro": [
    "/images/properties/greenpak-hotel-fort-munro-0.jpg",
    "/images/properties/greenpak-hotel-fort-munro-1.jpeg",
    "/images/properties/greenpak-hotel-fort-munro-2.jpg",
    "/images/properties/greenpak-hotel-fort-munro-4.jpg",
  ],
  "greenpak-hotel-katas-raj": [
    "/images/properties/greenpak-hotel-katas-raj-0.jpg",
    "/images/properties/greenpak-hotel-katas-raj-1.jpg",
    "/images/properties/greenpak-hotel-katas-raj-2.jpg",
    "/images/properties/greenpak-hotel-katas-raj-3.jpg",
  ],
  "greenpak-lagoon-gadani": [
    "/images/properties/greenpak-lagoon-gadani-0.jpg",
    "/images/properties/greenpak-lagoon-gadani-1.jpg",
    "/images/properties/greenpak-lagoon-gadani-2.jpg",
  ],
  "greenpak-broadbeach-sonmiani": [
    "/images/properties/greenpak-broadbeach-sonmiani-0.jpg",
    "/images/properties/greenpak-broadbeach-sonmiani-1.jpg",
    "/images/properties/greenpak-broadbeach-sonmiani-2.jpg",
    "/images/properties/greenpak-broadbeach-sonmiani-3.jpg",
  ],
};

/** Normalize nested catalog paths to flat design assets when possible. */
export function flatImage(key: string, fallback = "/images/hunza-valley-rakaposhi.webp"): string {
  if (key.startsWith("/images/properties/")) return key;

  const normalized = key.replace(/^\/images\/(?:attractions|heritage|azad-kashmir|islamabad|properties|tours)\//, "");
  const base = normalized.replace(/\.(jpg|jpeg|webp|png)$/i, "").replace(/-0$/, "");
  const slug = base.split("/").pop() ?? base;

  const propertySlug = slug.replace(/-\d+$/, "").replace(/-room-.*$/, "");
  if (PROPERTY_CARD[propertySlug]) return PROPERTY_CARD[propertySlug];

  return (
    FLAT_BY_SLUG[propertySlug] ??
    FLAT_BY_SLUG[slug] ??
    FLAT_BY_SLUG[slug.replace(/-national-park$/, "")] ??
    FLAT_BY_SLUG[slug.replace(/-temples$/, "")] ??
    (key.startsWith("/images/") && !key.includes("/attractions/") && !key.includes("/heritage/")
      ? key
      : fallback)
  );
}

export function imageForSlug(slug: string, fallback?: string): string {
  return flatImage(slug, fallback ?? "/images/hunza-valley-rakaposhi.webp");
}

/** Canonical card image for each GreenPak property slug. */
export function propertyImage(slug: string, catalogPath?: string | null): string {
  if (catalogPath?.startsWith("/images/properties/")) return catalogPath;
  if (PROPERTY_CARD[slug]) return PROPERTY_CARD[slug];
  if (catalogPath?.startsWith("/images/")) return flatImage(catalogPath, PROPERTY_CARD[slug] ?? "/images/hotel-hunza.jpg");
  return PROPERTY_CARD[slug] ?? `/images/properties/${slug}-0.jpg`;
}

/** Gallery images for stay detail pages, real property photos only. */
export function propertyGallery(slug: string, max = 5): string[] {
  const gallery = PROPERTY_GALLERY[slug] ?? (PROPERTY_CARD[slug] ? [PROPERTY_CARD[slug]] : []);
  return gallery.slice(0, max);
}

export function listPropertySlugs() {
  return Object.keys(PROPERTY_CARD);
}
